import { initializeSignicatService } from './signicat/signicat.js'
import { addScript } from '../addScript.js'

const eIdProvidersInit = {
  signicat: initializeSignicatService
}

/**
 * type config {
 *   sdkUrl: string;
 *   provider: string; // "signicat", "microblink"
 *   service: string; // "videoIdMedium", "
 *   serviceProvider: string; // "onfido", "blink"
 * }
 * @param config
 */
export async function initializeEid(config, chat){
  const { provider } = config
  try {
    // Load the eid provider into the app
    await eIdProvidersInit[provider](config, chat)
  } catch(error) {
    console.log("Error initializing EID: ", error)
    throw error
  }
}

export async function loadSdk (sdkUrl){
  return new Promise((resolve, reject)=>{
      addScript(document, sdkUrl, ()=>{
        console.log("Sdk successfully loaded")
        resolve()
      })
  })
}